(function () {
  "use strict";

  var root = document.querySelector("[data-jst-pdp]");
  if (!root) return;

  function syncHeaderOffsets() {
    var header = document.querySelector("[data-jst-header]");
    var stickyTop = header ? Math.round(header.getBoundingClientRect().height) : 0;
    var startOffset = Math.round(root.getBoundingClientRect().top + window.scrollY);
    if (stickyTop > 0) root.style.setProperty("--pdp-sticky-top", stickyTop + "px");
    if (startOffset > 0) root.style.setProperty("--pdp-start-offset", startOffset + "px");
  }
  syncHeaderOffsets();
  window.addEventListener("resize", syncHeaderOffsets, { passive: true });

  function bindSlider(track, prev, next, counter, thumbs) {
    if (!track) return;
    if (track.dataset.sliderBound === "true") return;
    track.dataset.sliderBound = "true";
    var slides = Array.prototype.slice.call(track.children);
    if (!slides.length) return;

    function activeIndex() {
      var left = track.scrollLeft;
      var best = 0;
      var distance = Infinity;
      slides.forEach(function (slide, index) {
        var d = Math.abs(slide.offsetLeft - left);
        if (d < distance) { distance = d; best = index; }
      });
      return best;
    }

    var thumbButtons = thumbs ? Array.prototype.slice.call(thumbs.querySelectorAll("[data-pdp-thumb]")) : [];

    function update() {
      var index = activeIndex();
      if (counter) counter.textContent = String(index + 1).padStart(2, "0") + " / " + String(slides.length).padStart(2, "0");
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;

      // المصغّرة النشطة تتبع الشريحة سواء وصلها الزائر بالسهم أو بالسحب أو
      // بنقر مصغّرة أخرى — الحالة تُقرأ من موضع التمرير لا من آخر نقرة.
      thumbButtons.forEach(function (button, i) {
        var on = i === index;
        button.setAttribute("aria-selected", on ? "true" : "false");
        button.classList.toggle("is-active", on);
        if (on && thumbs && thumbs.scrollWidth > thumbs.clientWidth) {
          var left = button.offsetLeft - (thumbs.clientWidth - button.clientWidth) / 2;
          thumbs.scrollTo({ left: Math.max(0, left), behavior: "smooth" });
        }
      });
    }

    function go(delta) {
      var index = Math.max(0, Math.min(slides.length - 1, activeIndex() + delta));
      track.scrollTo({ left: slides[index].offsetLeft, behavior: "smooth" });
    }

    if (prev) prev.addEventListener("click", function () { go(-1); });
    if (next) next.addEventListener("click", function () { go(1); });

    thumbButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        var index = parseInt(button.getAttribute("data-index"), 10);
        if (isNaN(index) || !slides[index]) return;
        track.scrollTo({ left: slides[index].offsetLeft, behavior: "smooth" });
      });
    });
    var scheduled = false;
    track.addEventListener("scroll", function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; update(); });
    }, { passive: true });
    window.addEventListener("resize", update, { passive: true });
    update();
  }

  bindSlider(
    root.querySelector("[data-pdp-gallery]"),
    root.querySelector("[data-pdp-prev]"),
    root.querySelector("[data-pdp-next]"),
    root.querySelector("[data-pdp-counter]"),
    root.querySelector("[data-pdp-thumbs]")
  );

  var dialog = root.querySelector("[data-pdp-dialog]");
  var dialogImage = dialog && dialog.querySelector("img");
  root.querySelectorAll("[data-pdp-zoom]").forEach(function (button) {
    button.addEventListener("click", function () {
      if (!dialog || !dialogImage || !dialog.showModal) return;
      dialogImage.src = button.getAttribute("data-zoom-src") || "";
      dialogImage.alt = button.getAttribute("data-zoom-alt") || "";
      dialog.showModal();
    });
  });
  if (dialog) {
    var close = dialog.querySelector("[data-pdp-dialog-close]");
    if (close) close.addEventListener("click", function () { dialog.close(); });
    dialog.addEventListener("click", function (event) {
      if (event.target === dialog) dialog.close();
    });
  }

  var feedback = root.querySelector("[data-pdp-feedback]");
  var productData = {
    id: root.getAttribute("data-product-id") || "",
    handle: root.getAttribute("data-product-handle") || "",
    title: root.getAttribute("data-product-title") || document.title,
    url: root.getAttribute("data-product-url") || window.location.pathname
  };

  function announce(message) {
    if (!feedback) return;
    feedback.textContent = message;
    window.clearTimeout(announce.timer);
    announce.timer = window.setTimeout(function () { feedback.textContent = ""; }, 3200);
  }

  root.querySelectorAll("[data-pdp-share]").forEach(function (button) {
    button.addEventListener("click", function () {
      var url = new URL(productData.url, window.location.origin).href;
      var payload = { title: productData.title, url: url };
      if (navigator.share) {
        navigator.share(payload).catch(function (error) {
          if (error && error.name !== "AbortError") announce((window.JUSTSTART.i18n && window.JUSTSTART.i18n.shareFailed) || "Could not share this product");
        });
        return;
      }
      var copied = navigator.clipboard && window.isSecureContext ? navigator.clipboard.writeText(url) : Promise.reject();
      copied.then(function () {
        announce((window.JUSTSTART.i18n && window.JUSTSTART.i18n.linkCopied) || "Product link copied");
      }).catch(function () {
        window.prompt((window.JUSTSTART.i18n && window.JUSTSTART.i18n.copyLink) || "Copy product link", url);
      });
    });
  });

  var wishlistKey = "jst_wishlist_v1";
  var wishlistButtons = root.querySelectorAll("[data-pdp-wishlist]");
  function readWishlist() {
    try {
      var value = JSON.parse(localStorage.getItem(wishlistKey) || "[]");
      return Array.isArray(value) ? value : [];
    } catch (error) { return []; }
  }
  function isSaved(items) { return items.some(function (item) { return String(item.id) === String(productData.id); }); }
  function syncWishlist(saved) {
    wishlistButtons.forEach(function (button) {
      button.setAttribute("aria-pressed", saved ? "true" : "false");
      button.setAttribute("aria-label", saved
        ? ((window.JUSTSTART.i18n && window.JUSTSTART.i18n.removeWishlist) || "Remove from favorites")
        : ((window.JUSTSTART.i18n && window.JUSTSTART.i18n.addWishlist) || "Add to favorites"));
    });
  }
  syncWishlist(isSaved(readWishlist()));
  wishlistButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      var items = readWishlist();
      var saved = isSaved(items);
      items = saved
        ? items.filter(function (item) { return String(item.id) !== String(productData.id); })
        : items.concat([productData]);
      try { localStorage.setItem(wishlistKey, JSON.stringify(items)); } catch (error) {}
      window.dispatchEvent(new CustomEvent("jst:wishlist-change", { detail: { items: items } }));
      syncWishlist(!saved);
      announce(!saved
        ? ((window.JUSTSTART.i18n && window.JUSTSTART.i18n.wishlistAdded) || "Added to favorites")
        : ((window.JUSTSTART.i18n && window.JUSTSTART.i18n.wishlistRemoved) || "Removed from favorites"));
    });
  });
})();
